import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Avoided redundant navigation to current location
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        },
        {
          path: 'product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: title + '-公司产品'
          },
          children: [
            {
              path: '',
              redirect: 'su'
            },
            {
              path: 'su',
              name: 'product',
              component: resolve => require(['@/view/Product_SU'], resolve),
              meta: {
                title: '公司产品丨动环监控采集主机'
              }
            },
            // {
            //   path: 'model',
            //   name: 'product',
            //   component: resolve => require(['@/view/Product_Model'], resolve),
            //   meta: {
            //     title: '公司产品丨动环测控模块'
            //   }
            // },
            {
              path: 'box',
              name: 'box',
              component: resolve => require(['@/view/Product_Box'], resolve),
              meta: {
                title: '公司产品丨智能箱体'
              }
            },
            {
              path: 'doorControl',
              name: 'doorControl',
              component: resolve => require(['@/view/Product_DoorControl'], resolve),
              meta: {
                title: '公司产品丨门禁控制器'
              }
            },
            {
              path: 'batteryCheck',
              name: 'batteryCheck',
              component: resolve => require(['@/view/Product_BatteryCheck'], resolve),
              meta: {
                title: '公司产品丨电池检测模块'
              }
            },
            {
              path: 'batteryProtect',
              name: 'batteryProtect',
              component: resolve => require(['@/view/Product_BatteryProtect'], resolve),
              meta: {
                title: '公司产品丨电源保护器'
              }
            },
            {
              path: 'modul',
              name: 'modul',
              component: resolve => require(['@/view/Product_Modul'], resolve),
              meta: {
                title: '公司产品丨动环采集模块'
              }
            }
          ]
        },
        {
          path: 'service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: title + '-解决方案'
          },
          children: [
            {
              path: '/',
              name: 'service',
              redirect:"datacenter"
              
            },
            ,{
              path: 'datacenter',
              name: 'datacenter',
              component: resolve => require(['@/view/Service_Datacenter'], resolve),
              meta: {
                title: '解决方案丨数据中心管理平台'
              }
            },
            {
              path: 'distributed',
              name: 'distributed',
              component: resolve => require(['@/view/Service_Distributed'], resolve),
              meta: {
                title: '解决方案丨分布式机房管理平台'
              }
            },
            {
              path: 'publicVideo',
              name: 'publicVideo',
              component: resolve => require(['@/view/Service_PublicVideo'], resolve),
              meta: {
                title: '解决方案丨公共视频智能运维平台'
              }
            },
            {
              path: 'doorManager',
              name: 'doorManager',
              component: resolve => require(['@/view/Service_DoorManager'], resolve),
              meta: {
                title: '解决方案丨门禁管理'
              }
            },
            {
              path: 'energyManager',
              name: 'energyManager',
              component: resolve => require(['@/view/Service_EnergyManager'], resolve),
              meta: {
                title: '解决方案丨电池检测模块'
              }
            },
            {
              path: 'batteryCheckSystem',
              name: 'batteryCheckSystem',
              component: resolve => require(['@/view/Service_BatteryCheckSystem'], resolve),
              meta: {
                title: '解决方案丨电池监测系统'
              }
            },
          ]
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-新闻动态'
          }
        },
        {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        },
        {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: title + '-工作机会'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js